import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Home from "../../pages/Home/Home";
import About from "../../pages/About/About";
import CurrentProperties from "../../pages/Portfolio/CurrentProperties/CurrentProperties";
import Investments from "../../pages/Investments/Investments";
import PropertyServices from "../../pages/PropertyServices/PropertyServices";
import SPiServices from "../../pages/SPiServices/SPiServices";
import Contact from "../../pages/Contact/Contact";
import PastProperties from "../../pages/Portfolio/PastProperties/PastProperties";

const BASEURL = process.env.REACT_APP_SOMPROP_BASE_URL;

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State for mobile menu
  const [submenu, setsubmenu] = useState(false);
 
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setIsSticky(offset > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleHamBurger = () => {
    // Toggle the menu state
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    // Close the menu when a link is clicked
    setIsMenuOpen(false);
  };

  

  const showSubMenu = () => {
    setsubmenu(!submenu)
  }


  return (

    <div className={`header ${isSticky ? "sticky" : ""}`} id="header">
      <div className="container-fluid">
        <div className="nav-brand-parent clearfix">
          <div className="navlist">
            <div className="logo">
              <h1>
                <span className="visually-hidden">Somerset Properties</span>
                <Link to="/" element={<Home />}>
                  <img
                    src={`${BASEURL}/images/logo.svg`}
                    width="215"
                    height="81"
                    alt="Logo"
                  />
                </Link>
              </h1>
            </div>
            <div className="navbar-header">
              <button
                type="button"
                className={`navbar-toggle navbar-toggler ${
                  isMenuOpen ? "open active" : ""
                }`}
                data-bs-toggle="collapse"
                data-bs-target="#example-navbar-collapse"
                aria-controls="example-navbar-collapse"
                aria-expanded={isMenuOpen ? "true" : "false"}
                aria-label="navigation"
                onClick={handleHamBurger}
              >
                <span className="navbar-toggler-icon"></span>
                <span className="navbar-toggler-icon"></span>
                <span className="navbar-toggler-icon"></span>
                <span className="sr-only">MENU</span>
              </button>
            </div>
          </div>
          <nav
            className={`navbar navbar-default navbar-expand-lg clearfix ${
              isMenuOpen ? "open" : ""
            }`}
            role="navigation"
          >
            <div
              className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}
              id="example-navbar-collapse"
            >
              <ul className="nav navbar-nav" id="mainmenu">
                <li>
                  <Link to="/" onClick={closeMenu} element={<Home />} >
                    HOME
                  </Link>
                </li>
                <li>
                  <Link to={"/about"} onClick={closeMenu} element={<About />}>
                    ABOUT
                  </Link>
                </li>
                <li>
                  <Link to="#" >
                    PORTFOLIO
                    <span className={`${submenu ? 'open' : ''}`} onClick={showSubMenu}></span>
                  </Link>

                    <ul style={{ display: submenu ? 'block' : 'none' }}>
                      <li>
                        <Link
                          to={"/current-properties"}
                          onClick={closeMenu}
                          element={<CurrentProperties />}
                        >
                          CURRENT PROPERTIES
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={"/past-properties"}
                          onClick={closeMenu}
                          element={<PastProperties />}
                        >
                          PAST PROPERTIES
                        </Link>
                      </li>
                  </ul>
                 
                 
                </li>
                <li>
                  <Link
                    to={"/investments"}
                    onClick={closeMenu}
                    element={<Investments />}
                  >
                    INVESTMENTS
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/property-services"}
                    onClick={closeMenu}
                    element={<PropertyServices />}
                  >
                    PROPERTY SERVICES
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/spi-services"}
                    onClick={closeMenu}
                    element={<SPiServices />}
                  >
                    SPi SERVICES
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/contact"}
                    onClick={closeMenu}
                    element={<Contact />}
                  >
                    CONTACT
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Header;
